import usePressGesture from './touch/usePressGesture';
/**
 * Touch gestures for a list row: swipe left and long press. Same as `usePressGesture`; kept
 * under this name for code written before the shared touch rules.
 *
 * @example
 * ```tsx
 * const gestures = useRowGestures({ onSwipeLeft: openActions, onLongPress: startSelecting });
 * <div {...gestures.handlers} onClick={(e) => { if (gestures.consumeClick()) return; open(); }} />
 * ```
 * @export
 */
const useRowGestures = usePressGesture;
export default useRowGestures;
